<template>
    <v-dialog v-model="dialog" persistent content-class="modal-dialog">
        <v-card class="modal-waiting">
            <div class="common-text mb-2" v-if="title">
                {{title}}
            </div>
            <div class="main-text mb-5" :class="{'text-center': textCenter}" v-if="text" v-html="text"></div>
            <v-img v-if="!noLoading" class="connection-animate" height="42px" width="42px" :src="require('@/assets/icons/connection.png')"></v-img>
            <v-flex class="d-flex w-100 justify-end mt-6" v-if="!noCancel">
                <v-btn class="btn-grey main-text" @click="close">
                    {{textBtn}}
                </v-btn>
            </v-flex>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "ModalWaiting",
    props: {
        value: {
            type: Boolean,
        },
        title: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        textBtn: {
            type: String,
            default: "Отмена",
        },
        noCancel: {
            type: Boolean,
            default: false,
        },
        noLoading: {
            type: Boolean,
            default: false,
        },
        textCenter: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            dialog: false,
        }
    },
    watch: {
        value(val) {
            if (val != this.dialog) {
                this.dialog = val;
            }
        },
    },
    methods: {
        open() {
            this.dialog = true;
        },
        close() {
            this.dialog = false;
            this.$emit('input', false);
        },
    }

}
</script>

<style lang="scss" scoped>
.modal-waiting.v-card {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
}

.connection-animate {
    animation: scale 1s infinite linear;
}
@keyframes scale {
    0% {
        transform: scaleX(-1);
    }
    50% {
        transform: scaleX(-1);
    }
    51% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(1);
    }
}

.btn-grey.v-btn {
    max-width: 94px;
    text-transform: none;
}
</style>